import {
  DECREMENT_MEDIA_GALLERY_IDX,
  INCREMENT_MEDIA_GALLERY_IDX
} from 'dpl/actions/breeder_profile_breed';


const validActions = [DECREMENT_MEDIA_GALLERY_IDX, INCREMENT_MEDIA_GALLERY_IDX];

export default function breederProfileBreedReducer(state = {}, action) {
  if (validActions.includes(action.type)) {
    const {
      video,
      photos,
      mediaGalleryIdx = 0
    } = state;

    // TODO: Handle video stand-in image
    const numItems = [
      video,
      ...(photos || [])
    ].filter(Boolean).length;

    return {
      ...state,
      mediaGalleryIdx: action.type === DECREMENT_MEDIA_GALLERY_IDX
        ? ((mediaGalleryIdx - 1) + numItems) % numItems
        : ((mediaGalleryIdx + 1) + numItems) % numItems
    };
  }

  return state;
}
